import { z } from 'zod';

export const CoreS3FileScalarFieldEnumSchema = z.enum(['id','cityId','uuid','usage','s3Key','bucket','s3StorageClass','status','sizeInBytes','originalFileName','fileExtension','fileUpdatedAt','createdAt','updatedAt','deleteRequestedAt','deletedAt']);

export default CoreS3FileScalarFieldEnumSchema;
